const projectBoxes = document.querySelectorAll('.js-project-description');
const sliderImages = document.querySelectorAll('.js-homepage-slider-cell');

for (let i = 0; i < sliderImages.length; i++) {
    sliderImages[i].addEventListener("mouseover", () => {
        gsap.to(projectBoxes[i], {autoAlpha: 1, y: '-65px', duration: 0.6, ease: "power4.easeInOut"});
    });
    sliderImages[i].addEventListener("mouseout", () => {
        gsap.to(projectBoxes[i], {autoAlpha: 0, y: '65px', duration: 0.6, ease: "power4.easeInOut"});
    });
}